import { WHATSAPP_NUMBER } from '../../../constants/homeData';
import Reveal from '../../common/Reveal';
import backgroundImage from '../../../assets/images/community.svg';
import whatsappIcon from '../../../assets/images/whatsapp.svg';

function LeftDecor() {
  return (
    <div className="relative hidden h-48 w-44 shrink-0 lg:block xl:h-56 xl:w-52" aria-hidden>
      <span className="absolute left-0 top-0 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#5865F2] shadow-lg">
        <svg className="h-8 w-8 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037 12.3 12.3 0 00-.608 1.25 18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028 14.09 14.09 0 001.226-1.994.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z" />
        </svg>
      </span>
      <span className="absolute left-12 top-16 flex h-12 w-12 items-center justify-center rounded-xl bg-sky-400 shadow-md">
        <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13a3 3 0 100-6" />
        </svg>
      </span>
      <span className="absolute bottom-4 left-6 h-8 w-8 rounded-lg bg-amber-300 shadow" />
      <span className="absolute right-2 top-8 h-6 w-6 rounded-full bg-red-400 shadow" />
      <span className="absolute bottom-10 right-0 text-2xl">✈️</span>
    </div>
  );
}

function RightDecor() {
  return (
    <div className="relative hidden h-48 w-52 shrink-0 lg:block xl:h-56 xl:w-60" aria-hidden>
      <span className="absolute bottom-0 left-4 h-28 w-16 rounded-full bg-violet-300/80" />
      <span className="absolute bottom-0 left-16 h-32 w-[4.5rem] rounded-full bg-violet-400/90" />
      <span className="absolute bottom-0 right-4 h-28 w-16 rounded-full bg-violet-300/80" />
      <span className="absolute bottom-24 left-6 h-14 w-14 rounded-full bg-amber-200" />
      <span className="absolute bottom-28 left-20 h-16 w-16 rounded-full bg-amber-100" />
      <span className="absolute bottom-24 right-8 h-14 w-14 rounded-full bg-sky-200" />
    </div>
  );
}

function CommunitySection() {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}`;

  return (
    <section
      className="relative overflow-hidden bg-cover bg-center bg-no-repeat px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6">
        <div className="flex flex-1 flex-col items-center text-center">
          <Reveal variant="up">
            <h2 className="max-w-2xl text-2xl font-bold leading-snug text-[#1B1B1B] sm:text-[28px]">
              Join Our Community <span className="font-medium">& Get Access to Latest Updates By</span> Top Mentors
            </h2>
          </Reveal>
          <Reveal variant="zoom" delay={120}>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-3 rounded-xl border border-[#1A87CC] bg-white px-5 py-3 text-base font-semibold capitalize text-[#1B1B1B] shadow-sm transition-all duration-300 ease-out hover:border-[#1B1B1B] hover:bg-[#1B1B1B] hover:text-white hover:shadow-md sm:px-6 sm:text-lg xl:text-[20px]"
            >
              <img src={whatsappIcon} alt="" className="h-9 w-9 shrink-0" aria-hidden />
              Join Whatsapp Group
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default CommunitySection;
